import React, { useState, useCallback, useContext } from 'react'
import styled, { css } from 'styled-components'
import moment from 'moment'
import Picker from './Picker'
import { StyledCalendar } from './styled'
import { getValidDateNumber } from './helpers'
import { DashboardContext } from 'components/DashboardContext'
import DateIntervalForm from './DateIntervalForm'
import BranchList from './BranchList'
import { useTranslation } from 'react-i18next'
import { breakpoints } from 'helpers/utils'

const Container = styled.div`
position: relative;
width: ${({ pickerStyle }) => (pickerStyle === 'branch') ? '292px' : 'auto'};

${({ pickerStyle }) => (pickerStyle === 'dateCalendar') && css`
	display: flex;
	flex-direction: row;
	@media (max-width: 1200px) {
		flex-direction: row-reverse;
		margin-right: -3px;
	}
	@media (max-width: 768px) {
		margin-left: 3px;
	}
`}

@media (${breakpoints.mobile}) {
	position: static;
	width: 100%;
	@media (max-width: 576px) {
		width: 100%;
	}
}
`

const DatePicker = ({ btnText, interval, onConfirm, hideCalendar, formatedDate, pickerColor = '#ffffff', pickerType = 'date', dropdownItems = [], activeBranch, branchList = [] }) => {
	const [t] = useTranslation()
	const { activeDate: currentDate, setActiveDate: setCurrentDate } = useContext(DashboardContext)
	/* use true for show calendar in start app */
	const [calendarVisible, setCalendarVisible] = useState(false)
	const [month, setMonth] = useState(interval ? moment().month() - 1 : moment(currentDate).month() + 1)
	const [year, setYear] = useState(moment(interval ? new Date().setFullYear(new Date().getFullYear()) : currentDate).year())
	const handleDateChange = useCallback(({ year: y, month: m, day }, key) => () => {
		const validMonth = getValidDateNumber(m),
			validDay = getValidDateNumber(day)
		const validDate = `${y}-${validMonth}-${validDay}`
		if (!key) {
			setCurrentDate(moment(validDate))
		} else {
			setDayInterval(state => ({
				...state,
				[key]: validDate
			}))
		}
		setCalendarVisible(false)
	}, [setCurrentDate, setCalendarVisible])
	// start - date interval form state
	const [intervalFormVisible, setIntervalFormVisible] = useState(false)
	const [monthInterval, setMonthInterval] = useState({ monthFrom: moment().month(), monthTo: month })
	const [dayInterval, setDayInterval] = useState({ dayFrom: null, dayTo: moment(new Date()).format('YYYY-MM-DD') })
	// end - date interval form state
	const branchObj = branchList.find(({ id }) => activeBranch === id) || {}
	const commonProps = {
		currentDate,
		month,
		year,
		setMonth,
		setYear,
		setCalendarVisible: interval ? setIntervalFormVisible : setCalendarVisible,
		handleDateChange,
		calendarVisible,
		formatedDate,
		pickerType,
		activeBranch: branchObj.name,
		btnText: pickerType === 'date' ? t('dashboard_section.show') : `${t('common.strings.branch')}:`
	}
	const intervalFormProps = {
		year,
		setYear,
		monthInterval,
		dayInterval,
		setMonthInterval,
		setDayInterval,
		handleDateChange,
		setIntervalFormVisible,
		onConfirm,
		hideCalendar,
		setMonth
	}
	const branchProps = {
		dropdownItems: dropdownItems.map(item => ({
			...item,
			handleClick: () => {
				setCalendarVisible(false)
				item.handleClick()
			}
		})),
		activeBranch
	}

	let pickerStyle = 'branch'
	if(!interval && pickerType === 'branch') {
		pickerStyle = 'branch'
	}else if(!interval && pickerType === 'date') {
		pickerStyle = 'dateCalendar'
	}else if(interval && pickerType === 'date') {
		pickerStyle = 'dateInterval'
	}
	return (
		<Container
			className='dateCalendarWrapper'
			pickerStyle={pickerStyle}
		>
			<Picker
				{...commonProps}
				pickerStyle={pickerStyle}
				calendarVisible={calendarVisible}
			/>
			{calendarVisible && pickerStyle === 'branch' && <BranchList {...branchProps} />}
			{calendarVisible && pickerStyle === 'dateCalendar' && <StyledCalendar {...commonProps} />}
			{intervalFormVisible && pickerStyle === 'dateInterval' && <DateIntervalForm {...intervalFormProps} />}
		</Container>
	)
}

export default DatePicker
